import { getEventCoordinates } from '@dnd-kit/utilities';
import { tileSelectors } from '../atom.tile/_tile-input.style.js';
import { drawer } from './molecule.drawer.style.js';

let overlayRect;
let tileRect;

/**
 * Inspired by the built-in dnd-kit snapToCenter modifier.
 *
 * However, the built-in implementation is insufficient in our cases wherein
 * the DragOverlay may have different dimensions than the Draggable that it is
 * based on.
 *
 * Specifically the DragOverlay dimensions are cached on creation, but the
 * snapping does not apply until the next tick, which results in incorrect
 * rects. As such we implement the modifier such that the correct coords are
 * available on the first tick through DOM-inspections.
 */
const makeSnapToCenterModifier = ref => {
  return args => {
    if (!args.activatorEvent) {
      overlayRect = undefined;
      tileRect = undefined;
      return args.transform;
    }
    const activatorCoordinates = getEventCoordinates(args.activatorEvent);
    if (!activatorCoordinates) {
      return args.transform;
    }
    if (!overlayRect || !tileRect) {
      const target = args.activatorEvent.target;
      if (!(target instanceof HTMLElement)) {
        return args.transform;
      }
      const dragOverlayTile = target.closest(tileSelectors.tile());
      const drawerTile = ref.current?.querySelector(`.${drawer} ${tileSelectors.tile()}[data-id="${dragOverlayTile?.dataset["id"]}"]`);
      overlayRect = (dragOverlayTile ?? target).getBoundingClientRect();
      tileRect = (drawerTile ?? dragOverlayTile ?? target).getBoundingClientRect();
    }
    return {
      ...args.transform,
      x: args.transform.x + activatorCoordinates.x - overlayRect.left - tileRect.width / 2,
      y: args.transform.y + activatorCoordinates.y - overlayRect.top - tileRect.height / 2
    };
  };
};

export { makeSnapToCenterModifier };
//# sourceMappingURL=dnd-kit.modifier.snap-to-center.js.map
